import { get } from "lodash";

import BasicPieChart from "./BasicPieChart";

import { getBasicDataset } from "../utils/option_main";
import { ChartType } from "../types/global-type";
import { IChartFormValue } from "../types/form-type";
import { ITableData, IWrokspaceData } from "../types/table-type";
import CalculationDataByChart from "./CalculationDataByChart";

class PieChart extends BasicPieChart {
  public getDataset(
    formValue: IChartFormValue,
    tableData: ITableData,
    workspaceData: IWrokspaceData,
    calculation: CalculationDataByChart
  ) {
    const result = getBasicDataset(formValue, tableData, workspaceData, ChartType.PIE_RING, this.calculation);
    const sortTransForm = this.getPieSortTransform(get(result, "[0].dimensions[1]"));
    result.push(sortTransForm);
    return result;
  }

  public getSeries(formValue: IChartFormValue, tableData: ITableData, workspaceData: IWrokspaceData) {
    const series = [
      {
        ...this.getBasicPieSeries(formValue),
      },
    ];
    return series;
  }
}

export default PieChart;
